export const translations = {
  en: {
    // Header
    'nav.events': 'Events',
    'nav.venue': 'The Venue',
    'nav.privateEvents': 'Private Events',
    'nav.gallery': 'Gallery',
    'nav.contact': 'Contact',
    
    // Home Page
    'home.hero.blackTie': 'Join Us For Our Black Tie',
    'home.hero.grandOpening': 'Grand Opening Gala',
    'home.hero.brokzTitle': 'BROKZ NIERUCHOMOSCI',
    'home.hero.anniversary': '1 Year Anniversary',
    'home.hero.celebration': 'Celebrating Excellence in Real Estate',
    'home.hero.wineTitle': 'Wine Tasting',
    'home.hero.wineSubtitle': 'An Evening of Elegance',
    'home.hero.wineDescription': 'Premium Selection • Expert Guidance • Culinary Pairings',
    'home.hero.quote1': '"It is with great honor that we extend our invitation to the Black Tie Grand Opening Gala of Pawilon Krzyżanowskiego. This evening will be a celebration of elegance, culture, and tradition, marking the beginning of a new era for this historic venue."',
    'home.hero.quote1Author': 'Monika, Organiser',
    'home.hero.quote2': '"We are proud to unveil Pawilon Krzyżanowskiego as a distinguished destination for gatherings of the highest caliber. The Grand Opening Gala is not only a celebration of this vision realized, but also an invitation to become part of its enduring story."',
    'home.hero.quote2Author': 'Szymon, Investor & Organiser',
    'home.hero.wineQuote': '"Each glass tells a story, each sip reveals a journey. Experience the art of wine appreciation in the sophisticated setting of Pawilon Krzyżanowskiego."',
    'home.hero.wineQuoteAuthor': 'Wine Curator',
    'home.events.title': 'EVENTS',
    'home.events.subtitle': 'Upcoming',
    'home.events.getTickets': 'Get Tickets',
    'home.events.loading': 'Loading events...',
    'home.events.noEvents': 'No upcoming events',
    'home.about.title': 'ABOUT THE VENUE',
    'home.about.subtitle': 'For Those Considering Our Pawilon',
    'home.about.description1': 'Pawilon Krzyżanowskiego is a stage for life\'s most meaningful moments, blending timeless architecture with modern refinement.',
    'home.about.description2': 'We welcome hosts and guests to create experiences that remain etched in memory.',
    'home.about.hosting': 'Hosting',
    'home.about.privateEvents': 'Private Events',
    'home.about.explore': 'Explore',
    'home.about.theVenue': 'The Venue',
    'home.about.the': 'The',
    'home.about.pawilonExperience': 'Pawilon Experience',
    'home.booking.subtitle': 'Pawilon Krzyżanowskiego',
    'home.booking.title': 'Book A Private Event',
    'home.booking.description1': 'Our elegant venue provides the perfect setting for intimate gatherings and special celebrations.',
    'home.booking.description2': 'Accommodating up to 50 sitting guests, it offers a sophisticated atmosphere that blends historic charm with modern amenities, ensuring every occasion feels memorable.',
    'home.booking.button': 'Book An Event',
    'home.newsletter.subtitle': 'Stay Connected',
    'home.newsletter.title': 'Be First to Know About Our Events',
    'home.newsletter.description1': 'From elegant evenings to grand public celebrations, every upcoming event at Pawilon Krzyżanowskiego comes directly to your inbox.',
    'home.newsletter.description2': 'Sign up and never miss an invitation to unforgettable moments.',
    'home.newsletter.name': 'Name',
    'home.newsletter.email': 'E-mail',
    'home.newsletter.subscribe': 'Subscribe',
    
    // Events Page
    'events.title': 'EVENTS',
    'events.subtitle': 'Experience Unforgettable Moments',
    'events.hero.subtitle': 'Discover our upcoming and past events at Pawilon Krzyżanowskiego',
    'events.getTickets': 'Get Tickets',
    'events.infoOnly': 'Info Only',
    'events.freeEntry': 'Free Entry',
    'events.contactUs': 'Contact Us',
    'events.soldOut': 'Sold Out',
    'events.almostSoldOut': 'Almost Sold Out',
    'events.limitedSpots': 'Limited Spots',
    'events.available': 'Available',
    'events.upcoming': 'Upcoming Events',
    'events.past': 'Past Events',
    'events.completed': 'Completed',
    'events.viewDetails': 'View Details',
    'events.hideDetails': 'Hide Details',
    'events.schedule': 'Event Schedule',
    'events.details': 'Event Details',
    'events.dressCode': 'Dress Code',
    'events.duration': 'Duration',
    'events.capacity': 'Capacity',
    'events.availableSeats': 'Available Seats',
    'events.inclusions': 'Inclusions',
    'events.specialFeatures': 'Special Features',
    'events.location': 'Location & Contact',
    'events.venue': 'Venue',
    'events.address': 'Address',
    'events.loadingError': 'Error Loading Events',
    'events.loadFailed': 'Load failed',
    'events.tryAgain': 'Try Again',
    'events.noEvents': 'No Events Scheduled',
    
    // Cart Page
    'cart.title': 'Checkout',
    'cart.selectEvent': 'Select an event to add...',
    'cart.addAnother': 'Add Another Event',
    'cart.closeSelector': 'Close Event Selector',
    'cart.soldOut': '(Sold Out)',
    'cart.attendeeInfo': 'Attendee Information',
    'cart.event': 'Event',
    'cart.attendee': 'Attendee',
    'cart.name': 'Full Name',
    'cart.email': 'Email',
    'cart.orderSummary': 'Order Summary',
    'cart.perTicket': 'per ticket',
    'cart.subtotal': 'Subtotal',
    'cart.total': 'Total',
    'cart.proceedPayment': 'Proceed to Payment',
    'cart.payment': 'Payment Information',
    'cart.cardNumber': 'Card Number',
    'cart.expiryDate': 'Expiry Date',
    'cart.cvv': 'CVV',
    'cart.cardholderName': 'Cardholder Name',
    'cart.billingAddress': 'Billing Address',
    'cart.city': 'City',
    'cart.postalCode': 'Postal Code',
    'cart.country': 'Country',
    'cart.promoCode': 'Promo Code',
    'cart.enterPromoCode': 'Enter promo code',
    'cart.apply': 'Apply',
    'cart.checking': 'Checking...',
    'cart.promoApplied': 'Promo code applied! Discount: {discount}%',
    'cart.promoRemoved': 'Promo code removed',
    'cart.invalidPromo': 'Invalid promo code',
    'cart.enterPromo': 'Please enter a promo code',
    'cart.promoError': 'Error validating code',
    'cart.remove': 'Remove',
    'cart.discount': 'Discount',
    'cart.off': 'off',
    'cart.backToEvents': 'Back to Events',
    'cart.completePayment': 'Complete Payment',
    
    // Footer
    'footer.venue': 'Pawilon Krzyżanowskiego',
    'footer.address': 'Ul. Garbary 96',
    'footer.cityCountry': '61-757 Poznań, Poland',
    'footer.quickLinks': 'Quick Links',
    'footer.followUs': 'Follow Us',
    'footer.rights': 'All rights reserved.',
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms of Service',
    
    // Private Events Page
    'private.hero.title': 'Private Events',
    'private.hero.subtitle': 'Host unforgettable celebrations in our exclusive venue',
    'private.intro.title': 'Your Event, Our Venue',
    'private.intro.description': 'Pawilon Krzyżanowskiego can be rented exclusively for private use. Our historic venue offers the main hall and additional spaces with a combined capacity for intimate gatherings and larger celebrations. The building is always rented as a whole, ensuring complete privacy and exclusivity for your special occasion.',
    'private.features.mainHall': 'Main Hall',
    'private.features.mainHallDesc': 'Up to 50 seated guests',
    'private.features.exclusive': 'Exclusive Rental',
    'private.features.exclusiveDesc': 'Entire venue for your event',
    'private.features.catering': 'Catering Options',
    'private.features.cateringDesc': 'Customizable menus available',
    'private.events.title': 'Perfect For',
    'private.events.weddings': 'Weddings & Receptions',
    'private.events.corporate': 'Corporate Events',
    'private.events.celebrations': 'Private Celebrations',
    'private.events.galas': 'Galas & Fundraisers',
    'private.contact.title': 'Plan Your Event',
    'private.contact.description': 'Contact us to discuss your vision and receive a personalized quote.',
    'private.contact.button': 'Contact Us',
    'private.booking.title': 'Booking',
    'private.booking.subtitle': 'Options',
    'private.booking.description': 'Choose the rental style that best suits your event needs. Whether you prefer full control over every detail or want our team to handle the complete experience.',
    'private.booking.venueOnly': 'Venue-Only Rental',
    'private.booking.venueOnlyDesc': 'Client handles all details including catering, décor, and entertainment. Perfect for those who want complete creative control.',
    'private.booking.fullService': 'Full-Service Rental',
    'private.booking.fullServiceDesc': 'Our team organizes catering, staff, and setup for a complete experience. Let us handle every detail while you enjoy your event.',
    'private.amenities.title': 'What\'s',
    'private.amenities.subtitle': 'Included',
    'private.amenities.description': 'Every rental includes essential amenities and services to ensure your event runs smoothly and meets the highest standards of comfort and functionality.',
    'private.amenities.fullAccess': 'Full Access',
    'private.amenities.fullAccessDesc': 'Complete access to main hall, upper room, and rooftop bar',
    'private.amenities.soundSystem': 'Sound System',
    'private.amenities.soundSystemDesc': 'Professional ceiling sound system in every room',
    'private.amenities.flexibleLayouts': 'Flexible Layouts',
    'private.amenities.flexibleLayoutsDesc': 'Customizable room layouts and décor options',
    'private.amenities.avEquipment': 'AV Equipment',
    'private.amenities.avEquipmentDesc': 'Optional projector and screen for presentations',
    'private.amenities.climateControl': 'Climate Control',
    'private.amenities.climateControlDesc': 'Full heating and air conditioning throughout',
    'private.amenities.lighting': 'Lighting',
    'private.amenities.lightingDesc': 'Adjustable lighting options for perfect atmosphere',
    'private.cta.title': 'Ready to Plan Your Event?',
    'private.cta.description': 'Contact us to check availability or arrange a viewing. Our team is ready to help you create an unforgettable experience at Pawilon Krzyżanowskiego.',
    'private.cta.contact': 'Contact Us',
    'private.cta.viewEvents': 'View Public Events',
    
    // The Venue Page
    'venue.hero.title': 'The Venue',
    'venue.hero.subtitle': 'Discover our historic space and elegant facilities',
    'venue.main.title': 'A Historic Setting in the Heart of Poznan',
    'venue.main.description1': 'Pawilon Krzyżanowskiego stands at Garbary 96, less than 500 meters from Poznań\'s Old Town. The building, nearly 200 years old, carries the elegance of its history while offering the comfort and functionality needed for modern gatherings.',
    'venue.main.description2': 'From private celebrations to cultural evenings and public events, Pawilon Krzyżanowskiego provides a setting where history, elegance, and flexibility come together.',
    'venue.main.bookEvent': 'Book An Event',
    'venue.main.buyTickets': 'Buy Tickets',
    'venue.spaces.title': 'Our',
    'venue.spaces.subtitle': 'Spaces',
    'venue.spaces.description': 'Pawilon Krzyżanowskiego offers versatile spaces that adapt to your event\'s needs, from intimate gatherings to grand celebrations.',
    'venue.spaces.mainHall': 'Main Dining Hall',
    'venue.spaces.mainHallDesc': 'Our largest space, perfect for seated dinners and receptions. Features include elegant chandeliers, hardwood floors, and large windows providing natural light.',
    'venue.spaces.upperRoom': 'Upper Room',
    'venue.spaces.upperRoomDesc': 'A flexible space ideal for cocktail receptions, buffet setups, or as a separate area for activities. Modern amenities with historic charm.',
    'venue.spaces.rooftop': 'Rooftop',
    'venue.spaces.rooftopDesc': 'An open-air space perfect for summer gatherings and casual events. Offers views of historic Poznań and creates a relaxed atmosphere.',
    'venue.amenities.title': 'Venue',
    'venue.amenities.subtitle': 'Amenities',
    'venue.amenities.sound': 'Professional Sound System',
    'venue.amenities.soundDesc': 'Ceiling-mounted speakers throughout all rooms',
    'venue.amenities.lighting': 'Customizable Lighting',
    'venue.amenities.lightingDesc': 'Adjustable ambiance for any occasion',
    'venue.amenities.climate': 'Climate Control',
    'venue.amenities.climateDesc': 'Full heating and air conditioning',
    'venue.amenities.av': 'AV Equipment',
    'venue.amenities.avDesc': 'Projector and screen available',
    'venue.amenities.furniture': 'Flexible Furniture',
    'venue.amenities.furnitureDesc': 'Customizable seating and table arrangements',
    'venue.amenities.parking': 'Nearby Parking',
    'venue.amenities.parkingDesc': 'Paid parking options within walking distance',
    'venue.location.title': 'Location',
    'venue.location.subtitle': 'Details',
    'venue.location.description': 'Situated at Ul. Garbary 96 in the heart of Poznań, Pawilon Krzyżanowskiego is easily accessible from all parts of the city.',
    'venue.location.address': 'Address',
    'venue.location.addressValue': 'Ul. Garbary 96, 61-757 Poznań',
    'venue.location.distance': 'Distance to Old Town',
    'venue.location.distanceValue': 'Less than 500 meters',
    'venue.location.transport': 'Public Transport',
    'venue.location.transportValue': 'Multiple tram and bus lines nearby',
    'venue.cta.title': 'Experience The Venue',
    'venue.cta.description': 'Visit us to see our historic spaces and envision your perfect event.',
    'venue.cta.button': 'Schedule a Visit',
    
    // Contact Page
    'contact.hero.title': 'Contact Us',
    'contact.hero.subtitle': 'Get in touch for bookings and inquiries',
    'contact.form.title': 'Send Us a Message',
    'contact.form.name': 'Name',
    'contact.form.email': 'Email',
    'contact.form.phone': 'Phone',
    'contact.form.message': 'Message',
    'contact.form.send': 'Send Message',
    'contact.info.title': 'Contact Information',
    'contact.info.address': 'Address',
    'contact.info.phone': 'Phone',
    'contact.info.email': 'Email',
    'contact.info.hours': 'Hours',
    'contact.info.hoursValue': 'By Appointment',
    
    // Ticket Pages
    'ticket.confirmation.title': 'Payment Successful',
    'ticket.confirmation.subtitle': 'Your tickets have been confirmed',
    'ticket.confirmation.download': 'Download Tickets',
    'ticket.confirmation.print': 'Print Tickets',
    'ticket.confirmation.backToEvents': 'Back to Events',
    'ticket.confirmation.importantInfo': 'Important Information',
    'ticket.confirmation.qrCode': 'QR Code',
    'ticket.confirmation.scanAtVenue': 'Scan this QR code at the venue',
    'ticket.confirmation.presentQR': 'Please present this QR code at the venue entrance',
    'ticket.confirmation.saveEmail': 'Save this email or take a screenshot of your QR code',
    'ticket.confirmation.questions': 'Questions? Contact us at:',
    
    'ticket.display.title': 'Your Ticket',
    'ticket.display.event': 'Event',
    'ticket.display.date': 'Date',
    'ticket.display.attendee': 'Attendee',
    'ticket.display.ticketNumber': 'Ticket Number',
    'ticket.display.ticketId': 'Ticket ID',
    'ticket.display.qrCode': 'QR Code',
    'ticket.display.scanAtEntry': 'Show this QR code at entry',
    'ticket.display.print': 'Print Ticket',
    'ticket.display.backToEvents': 'Back to Events',
    
    'ticket.verify.title': 'Ticket Verification',
    'ticket.verify.scanQR': 'Scan QR Code',
    'ticket.verify.enterCode': 'Or Enter Ticket Code',
    'ticket.verify.verify': 'Verify Ticket',
    'ticket.verify.valid': 'Valid Ticket',
    'ticket.verify.invalid': 'Invalid Ticket',
    'ticket.verify.expired': 'Expired Ticket',
    'ticket.verify.alreadyUsed': 'Already Used',
    'ticket.verify.eventName': 'Event',
    'ticket.verify.attendeeName': 'Attendee',
    'ticket.verify.ticketNumber': 'Ticket Number',
    'ticket.verify.scanCount': 'Scan Count',
    'ticket.verify.verifyAnother': 'Verify Another Ticket',
    'ticket.verify.enterTicketCode': 'Enter ticket code manually',
    'ticket.verify.manualVerification': 'Manual Verification',
    'ticket.verify.ticketCode': 'Ticket Code',
    'ticket.verify.checkQR': 'Please check the QR code and try again.',
    
    // Additional Cart and Checkout translations
    'cart.soldOutEvent': 'This event is sold out',
    'cart.selectEventFirst': 'Please select at least one event before proceeding to payment.',
    'cart.fillAttendeeInfo': 'Please fill in name and email for all attendees',
    'cart.provideAttendeeInfo': 'Please provide attendee information',
    'cart.paymentError': 'An error occurred while creating payment. Please try again.',
    'cart.securePayments': 'Secure payments powered by Stripe',
    'cart.acceptCards': 'We accept Visa, Mastercard, American Express',
    'cart.processing': 'Processing...',
    'cart.loading': 'Loading...',
    'cart.enterFullName': 'Enter full name',
    'cart.enterEmailAddress': 'Enter email address (your ticket will be sent here)',
    'cart.yourEvent': 'Your Event',
    'cart.tickets': 'Tickets',
    'cart.ticketRequired': 'ticket required',
    'cart.ticketsRequired': 'tickets required',
    'cart.quantity': 'Quantity:',
    'cart.selectEventToSeeDetails': 'Please select an event to see order details',
    
    // Ticket Confirmation additional translations
    'ticket.confirmation.noSessionId': 'No session ID found',
    'ticket.confirmation.fetchError': 'Failed to fetch tickets',
    'ticket.confirmation.fetchingTickets': 'Fetching tickets for session',
    'ticket.confirmation.errorFetching': 'Error fetching tickets',
    'ticket.confirmation.loadingTickets': 'Loading Your Tickets...',
    'ticket.confirmation.pleaseWait': 'Please wait while we retrieve your tickets.',
    'ticket.confirmation.error': 'Error',
    'ticket.confirmation.couldNotProcess': 'We couldn\'t process your ticket. Please contact support.',
    'ticket.confirmation.backToHome': 'Back to Home',
    'ticket.confirmation.noTicketsFound': 'No Tickets Found',
    'ticket.confirmation.couldNotFindTickets': 'We couldn\'t find any tickets for this session.',
    'ticket.confirmation.paymentSuccessful': 'Payment Successful',
    'ticket.confirmation.ticketSent': 'Your ticket has been sent to your email',
    'ticket.confirmation.ticketsSent': 'Your tickets have been sent to your email',
    'ticket.confirmation.ticketNumber': 'Ticket #',
    'ticket.confirmation.attendee': 'Attendee',
    'ticket.confirmation.date': 'Date',
    'ticket.confirmation.price': 'Price',
    'ticket.confirmation.status': 'Status',
    'ticket.confirmation.active': 'Active',
    'ticket.confirmation.scanQRAtVenue': 'Scan this QR code at the venue',
    'ticket.confirmation.ticketId': 'Ticket ID',
    'ticket.confirmation.copySent': 'A copy of your ticket has been sent to',
    'ticket.confirmation.copiesSent': 'A copy of your tickets has been sent to',
    'ticket.confirmation.presentQRCode': 'Please present this QR code at the venue entrance',
    'ticket.confirmation.ticketUsedOnce': 'Each ticket can only be used once',
    'ticket.confirmation.ticketsExpire': 'Tickets expire the day after the event',
    'ticket.confirmation.printTickets': 'Print Tickets',
    'ticket.confirmation.backToHomeButton': 'Back to Home',
    
    // Email template translations
    'email.ticket.hello': 'Hello,',
    'email.ticket.ticketsConfirmed': 'Your ticket has been confirmed! Below is your ticket with QR code for entry.',
    'email.ticket.ticketsConfirmedPlural': 'Your tickets have been confirmed! Below are your tickets with QR codes for entry.',
    'email.ticket.attendee': 'Attendee',
    'email.ticket.date': 'Date',
    'email.ticket.price': 'Price',
    'email.ticket.ticketId': 'Ticket ID',
    'email.ticket.showQRCode': 'Show this QR code at the venue entrance',
    'email.ticket.importantInfo': 'Important Information',
    'email.ticket.presentQRCode': 'Please present your QR code at the venue entrance',
    'email.ticket.ticketsExpire': 'Tickets expire the day after the event',
    'email.ticket.saveEmail': 'Save this email or take a screenshot of your QR code',
    'email.ticket.questions': 'Questions? Contact us at:',
    'email.ticket.printTickets': 'PRINT TICKETS',
    'email.ticket.backToHome': 'BACK TO HOME',
    
    // Ticket Display additional translations
    'ticket.display.ticketNotFound': 'Ticket not found',
    'ticket.display.loadingTicket': 'Loading ticket...',
    'ticket.display.error': 'Error',
    'ticket.display.yourTicket': 'Your Ticket',
    'ticket.display.active': 'Active',
    'ticket.display.expired': 'Expired',
    'ticket.display.cancelled': 'Cancelled',
    'ticket.display.showQRAtEntry': 'Show this QR code at entry',
    'ticket.display.name': 'Name',
    'ticket.display.email': 'Email',
    'ticket.display.eventDate': 'Event Date',
    'ticket.display.price': 'Price',
    'ticket.display.purchaseDate': 'Purchase Date',
    'ticket.display.expiredAfterEvent': 'This ticket expired the day after the event',
    'ticket.display.printTicket': 'Print Ticket',
    'ticket.display.browseEvents': 'Browse Events',
    
    // Ticket Verify additional translations
    'ticket.verify.scanning': 'Scanning...',
    'ticket.verify.markAsScanned': 'Mark as Scanned',
    'ticket.verify.verifyingTicket': 'Verifying Ticket...',
    'ticket.verify.pleaseWait': 'Please wait while we verify your ticket.',
    'ticket.verify.invalidTicket': 'Invalid Ticket',
    'ticket.verify.ticketNotExist': 'The ticket you\'re trying to verify does not exist or has been removed.',
    'ticket.verify.ticketVerification': 'Ticket Verification',
    'ticket.verify.validTicket': 'VALID TICKET',
    'ticket.verify.validForEntry': 'This ticket is valid for entry',
    'ticket.verify.expiredTicket': 'EXPIRED TICKET',
    'ticket.verify.noLongerValid': 'This ticket is no longer valid for entry',
    'ticket.verify.ticketId': 'Ticket ID',
    'ticket.verify.attendeeInformation': 'Attendee Information',
    'ticket.verify.name': 'Name',
    'ticket.verify.email': 'Email',
    'ticket.verify.scanned': 'Scanned',
    'ticket.verify.times': 'times',
    'ticket.verify.purchased': 'Purchased',
    'ticket.verify.clickToMark': 'Click this button when the attendee arrives to mark the ticket as scanned.',
    'ticket.verify.expiredOn': 'Expired on'
  },
  pl: {
    // Header
    'nav.events': 'Wydarzenia',
    'nav.venue': 'Lokal',
    'nav.privateEvents': 'Imprezy Prywatne',
    'nav.gallery': 'Galeria',
    'nav.contact': 'Kontakt',
    
    // Home Page
    'home.hero.blackTie': 'Zapraszamy Na Naszą Galę',
    'home.hero.grandOpening': 'Wielkie Otwarcie',
    'home.hero.brokzTitle': 'BROKZ NIERUCHOMOŚCI',
    'home.hero.anniversary': 'Rocznica 1 Rok',
    'home.hero.celebration': 'Świętujemy Doskonałość w Nieruchomościach',
    'home.hero.wineTitle': 'Degustacja Wina',
    'home.hero.wineSubtitle': 'Wieczór Elegancji',
    'home.hero.wineDescription': 'Wybór Premium • Ekspert Przewodnik • Kulinarne Pary',
    'home.hero.quote1': '"Z wielkim zaszczytem zapraszamy na Galę Wielkiego Otwarcia Pawilon Krzyżanowskiego w stroju wieczorowym. Ten wieczór będzie celebracją elegancji, kultury i tradycji, wyznaczając początek nowej ery dla tego historycznego miejsca."',
    'home.hero.quote1Author': 'Monika, Organizator',
    'home.hero.quote2': '"Z dumą przedstawiamy Pawilon Krzyżanowskiego jako wyróżniające się miejsce spotkań najwyższego kalibru. Gala Wielkiego Otwarcia to nie tylko celebracja zrealizowanej wizji, ale także zaproszenie do stania się częścią jej trwałej historii."',
    'home.hero.quote2Author': 'Szymon, Inwestor i Organizator',
    'home.hero.wineQuote': '"Każdy kieliszek opowiada historię, każdy łyk odkrywa podróż. Doświadcz sztuki doceniania wina w wyrafinowanym otoczeniu Pawilon Krzyżanowskiego."',
    'home.hero.wineQuoteAuthor': 'Kurator Win',
    'home.events.title': 'WYDARZENIA',
    'home.events.subtitle': 'Nadchodzące',
    'home.events.getTickets': 'Kup Bilety',
    'home.events.loading': 'Ładowanie wydarzeń...',
    'home.events.noEvents': 'Brak nadchodzących wydarzeń',
    'home.about.title': 'O LOKALU',
    'home.about.subtitle': 'Dla Rozważających Nasz Pawilon',
    'home.about.description1': 'Pawilon Krzyżanowskiego to scena dla najważniejszych chwil życia, łącząca ponadczasową architekturę z nowoczesnym wyrafinowaniem.',
    'home.about.description2': 'Witamy gospodarzy i gości, aby tworzyć doświadczenia, które pozostają w pamięci.',
    'home.about.hosting': 'Organizacja',
    'home.about.privateEvents': 'Imprezy Prywatne',
    'home.about.explore': 'Poznaj',
    'home.about.theVenue': 'Lokal',
    'home.about.the': 'Doświadczenie',
    'home.about.pawilonExperience': 'Pawilonu',
    'home.booking.subtitle': 'Pawilon Krzyżanowskiego',
    'home.booking.title': 'Zarezerwuj Prywatne Wydarzenie',
    'home.booking.description1': 'Nasz elegancki obiekt zapewnia idealne miejsce na kameralne spotkania i specjalne uroczystości.',
    'home.booking.description2': 'Pomieści do 50 gości siedzących, oferuje wyrafinowaną atmosferę, która łączy historyczny urok z nowoczesnymi udogodnieniami, zapewniając niezapomniane wrażenia przy każdej okazji.',
    'home.booking.button': 'Zarezerwuj Wydarzenie',
    'home.newsletter.subtitle': 'Pozostań w Kontakcie',
    'home.newsletter.title': 'Bądź Pierwszym, Który Dowie Się O Naszych Wydarzeniach',
    'home.newsletter.description1': 'Od eleganckich wieczorów po wielkie publiczne uroczystości, każde nadchodzące wydarzenie w Pawilon Krzyżanowskiego trafia bezpośrednio do Twojej skrzynki pocztowej.',
    'home.newsletter.description2': 'Zapisz się i nigdy nie przegap zaproszenia na niezapomniane chwile.',
    'home.newsletter.name': 'Imię',
    'home.newsletter.email': 'E-mail',
    'home.newsletter.subscribe': 'Zapisz się',
    
    // Events Page
    'events.title': 'WYDARZENIA',
    'events.subtitle': 'Przeżyj Niezapomniane Chwile',
    'events.hero.subtitle': 'Odkryj nasze nadchodzące i przeszłe wydarzenia w Pawilon Krzyżanowskiego',
    'events.getTickets': 'Kup Bilety',
    'events.infoOnly': 'Tylko Informacja',
    'events.freeEntry': 'Wstęp Bezpłatny',
    'events.contactUs': 'Skontaktuj się',
    'events.soldOut': 'Wyprzedane',
    'events.almostSoldOut': 'Prawie Wyprzedane',
    'events.limitedSpots': 'Ograniczone Miejsca',
    'events.available': 'Dostępne',
    'events.upcoming': 'Nadchodzące Wydarzenia',
    'events.past': 'Przeszłe Wydarzenia',
    'events.completed': 'Zakończone',
    'events.viewDetails': 'Zobacz Szczegóły',
    'events.hideDetails': 'Ukryj Szczegóły',
    'events.schedule': 'Program Wydarzenia',
    'events.details': 'Szczegóły Wydarzenia',
    'events.dressCode': 'Dress Code',
    'events.duration': 'Czas Trwania',
    'events.capacity': 'Pojemność',
    'events.availableSeats': 'Dostępne Miejsca',
    'events.inclusions': 'W Cenie',
    'events.specialFeatures': 'Specjalne Atrakcje',
    'events.location': 'Lokalizacja i Kontakt',
    'events.venue': 'Obiekt',
    'events.address': 'Adres',
    'events.loadingError': 'Błąd Ładowania Wydarzeń',
    'events.loadFailed': 'Ładowanie nie powiodło się',
    'events.tryAgain': 'Spróbuj Ponownie',
    'events.noEvents': 'Brak Zaplanowanych Wydarzeń',
    
    // Cart Page
    'cart.title': 'Kasa',
    'cart.selectEvent': 'Wybierz wydarzenie do dodania...',
    'cart.addAnother': 'Dodaj Kolejne Wydarzenie',
    'cart.closeSelector': 'Zamknij Wybór Wydarzenia',
    'cart.soldOut': '(Wyprzedane)',
    'cart.attendeeInfo': 'Informacje o Uczestnikach',
    'cart.event': 'Wydarzenie',
    'cart.attendee': 'Uczestnik',
    'cart.name': 'Imię i Nazwisko',
    'cart.email': 'Email',
    'cart.orderSummary': 'Podsumowanie Zamówienia',
    'cart.perTicket': 'za bilet',
    'cart.subtotal': 'Suma Częściowa',
    'cart.total': 'Razem',
    'cart.proceedPayment': 'Przejdź do Płatności',
    'cart.payment': 'Informacje o Płatności',
    'cart.cardNumber': 'Numer Karty',
    'cart.expiryDate': 'Data Ważności',
    'cart.cvv': 'CVV',
    'cart.cardholderName': 'Imię Posiadacza Karty',
    'cart.billingAddress': 'Adres Rozliczeniowy',
    'cart.city': 'Miasto',
    'cart.postalCode': 'Kod Pocztowy',
    'cart.country': 'Kraj',
    'cart.promoCode': 'Kod Promocyjny',
    'cart.enterPromoCode': 'Wprowadź kod promocyjny',
    'cart.apply': 'Zastosuj',
    'cart.checking': 'Sprawdzanie...',
    'cart.promoApplied': 'Kod promocyjny zastosowany! Zniżka: {discount}%',
    'cart.promoRemoved': 'Kod promocyjny usunięty',
    'cart.invalidPromo': 'Nieprawidłowy kod promocyjny',
    'cart.enterPromo': 'Wprowadź kod promocyjny',
    'cart.promoError': 'Błąd walidacji kodu',
    'cart.remove': 'Usuń',
    'cart.discount': 'Zniżka',
    'cart.off': 'zniżki',
    'cart.backToEvents': 'Powrót do Wydarzeń',
    'cart.completePayment': 'Zakończ Płatność',
    
    // Footer
    'footer.venue': 'Pawilon Krzyżanowskiego',
    'footer.address': 'Ul. Garbary 96',
    'footer.cityCountry': '61-757 Poznań, Polska',
    'footer.quickLinks': 'Szybkie Linki',
    'footer.followUs': 'Śledź Nas',
    'footer.rights': 'Wszelkie prawa zastrzeżone.',
    'footer.privacy': 'Polityka Prywatności',
    'footer.terms': 'Warunki Usługi',
    
    // Private Events Page
    'private.hero.title': 'Imprezy Prywatne',
    'private.hero.subtitle': 'Organizuj niezapomniane uroczystości w naszym ekskluzywnym obiekcie',
    'private.intro.title': 'Twoje Wydarzenie, Nasz Obiekt',
    'private.intro.description': 'Pawilon Krzyżanowskiego można wynająć wyłącznie na użytek prywatny. Nasz historyczny obiekt oferuje główną salę i dodatkowe przestrzenie o łącznej pojemności dla kameralnych spotkań i większych uroczystości. Budynek wynajmowany jest zawsze w całości, zapewniając pełną prywatność i ekskluzywność dla Twojej wyjątkowej okazji.',
    'private.features.mainHall': 'Sala Główna',
    'private.features.mainHallDesc': 'Do 50 gości siedzących',
    'private.features.exclusive': 'Wynajem Ekskluzywny',
    'private.features.exclusiveDesc': 'Cały obiekt na Twoje wydarzenie',
    'private.features.catering': 'Opcje Cateringowe',
    'private.features.cateringDesc': 'Dostępne menu do personalizacji',
    'private.events.title': 'Idealne Na',
    'private.events.weddings': 'Wesela i Przyjęcia',
    'private.events.corporate': 'Wydarzenia Korporacyjne',
    'private.events.celebrations': 'Prywatne Uroczystości',
    'private.events.galas': 'Gale i Zbiórki Funduszy',
    'private.contact.title': 'Zaplanuj Swoje Wydarzenie',
    'private.contact.description': 'Skontaktuj się z nami, aby omówić swoją wizję i otrzymać spersonalizowaną wycenę.',
    'private.contact.button': 'Skontaktuj się',
    'private.booking.title': 'Rezerwacja',
    'private.booking.subtitle': 'Opcje',
    'private.booking.description': 'Wybierz styl wynajmu, który najlepiej odpowiada potrzebom Twojego wydarzenia. Niezależnie od tego, czy wolisz pełną kontrolę nad każdym szczegółem, czy chcesz, aby nasz zespół zajął się całym doświadczeniem.',
    'private.booking.venueOnly': 'Wynajem Tylko Obiektu',
    'private.booking.venueOnlyDesc': 'Klient zajmuje się wszystkimi szczegółami, w tym cateringiem, dekoracją i rozrywką. Idealne dla tych, którzy chcą pełnej kreatywnej kontroli.',
    'private.booking.fullService': 'Wynajem z Pełną Obsługą',
    'private.booking.fullServiceDesc': 'Nasz zespół organizuje catering, personel i ustawienie dla pełnego doświadczenia. Pozwól nam zadbać o każdy szczegół, podczas gdy Ty cieszysz się swoim wydarzeniem.',
    'private.amenities.title': 'Co Jest',
    'private.amenities.subtitle': 'Wliczone',
    'private.amenities.description': 'Każdy wynajem obejmuje niezbędne udogodnienia i usługi, aby zapewnić płynny przebieg wydarzenia i spełnienie najwyższych standardów komfortu i funkcjonalności.',
    'private.amenities.fullAccess': 'Pełny Dostęp',
    'private.amenities.fullAccessDesc': 'Pełny dostęp do głównej sali, górnej sali i baru na dachu',
    'private.amenities.soundSystem': 'System Dźwiękowy',
    'private.amenities.soundSystemDesc': 'Profesjonalny sufitowy system dźwiękowy w każdym pomieszczeniu',
    'private.amenities.flexibleLayouts': 'Elastyczne Układy',
    'private.amenities.flexibleLayoutsDesc': 'Konfigurowalne układy pomieszczeń i opcje dekoracji',
    'private.amenities.avEquipment': 'Sprzęt AV',
    'private.amenities.avEquipmentDesc': 'Opcjonalny projektor i ekran do prezentacji',
    'private.amenities.climateControl': 'Kontrola Klimatu',
    'private.amenities.climateControlDesc': 'Pełne ogrzewanie i klimatyzacja w całym budynku',
    'private.amenities.lighting': 'Oświetlenie',
    'private.amenities.lightingDesc': 'Regulowane opcje oświetlenia dla idealnej atmosfery',
    'private.cta.title': 'Gotowy Zaplanować Swoje Wydarzenie?',
    'private.cta.description': 'Skontaktuj się z nami, aby sprawdzić dostępność lub umówić się na oglądanie. Nasz zespół jest gotowy pomóc Ci stworzyć niezapomniane doświadczenie w Pawilon Krzyżanowskiego.',
    'private.cta.contact': 'Skontaktuj się',
    'private.cta.viewEvents': 'Zobacz Wydarzenia Publiczne',
    
    // The Venue Page
    'venue.hero.title': 'Lokal',
    'venue.hero.subtitle': 'Odkryj naszą historyczną przestrzeń i eleganckie udogodnienia',
    'venue.main.title': 'Historyczne Miejsce w Sercu Poznania',
    'venue.main.description1': 'Pawilon Krzyżanowskiego znajduje się przy Garbary 96, mniej niż 500 metrów od Starego Miasta w Poznaniu. Budynek, liczący prawie 200 lat, niesie elegancję swojej historii, oferując jednocześnie komfort i funkcjonalność potrzebną do nowoczesnych spotkań.',
    'venue.main.description2': 'Od prywatnych uroczystości po wieczory kulturalne i wydarzenia publiczne, Pawilon Krzyżanowskiego zapewnia miejsce, w którym historia, elegancja i elastyczność łączą się razem.',
    'venue.main.bookEvent': 'Zarezerwuj Wydarzenie',
    'venue.main.buyTickets': 'Kup Bilety',
    'venue.spaces.title': 'Nasze',
    'venue.spaces.subtitle': 'Przestrzenie',
    'venue.spaces.description': 'Pawilon Krzyżanowskiego oferuje wszechstronne przestrzenie, które dostosowują się do potrzeb Twojego wydarzenia, od kameralnych spotkań po wielkie uroczystości.',
    'venue.spaces.mainHall': 'Główna Sala Jadalna',
    'venue.spaces.mainHallDesc': 'Nasza największa przestrzeń, idealna na kolacje przy stołach i przyjęcia. Wyposażenie obejmuje eleganckie żyrandole, podłogi z twardego drewna i duże okna zapewniające naturalne światło.',
    'venue.spaces.upperRoom': 'Górna Sala',
    'venue.spaces.upperRoomDesc': 'Elastyczna przestrzeń idealna na przyjęcia koktajlowe, bufety lub jako osobny obszar na aktywności. Nowoczesne udogodnienia z historycznym urokiem.',
    'venue.spaces.rooftop': 'Taras',
    'venue.spaces.rooftopDesc': 'Przestrzeń na świeżym powietrzu idealna na letnie spotkania i nieformalne wydarzenia. Oferuje widoki na historyczny Poznań i tworzy swobodną atmosferę.',
    'venue.amenities.title': 'Udogodnienia',
    'venue.amenities.subtitle': 'Lokalu',
    'venue.amenities.sound': 'Profesjonalny System Dźwiękowy',
    'venue.amenities.soundDesc': 'Głośniki sufitowe we wszystkich pomieszczeniach',
    'venue.amenities.lighting': 'Regulowane Oświetlenie',
    'venue.amenities.lightingDesc': 'Regulowana atmosfera na każdą okazję',
    'venue.amenities.climate': 'Kontrola Klimatu',
    'venue.amenities.climateDesc': 'Pełne ogrzewanie i klimatyzacja',
    'venue.amenities.av': 'Sprzęt AV',
    'venue.amenities.avDesc': 'Projektor i ekran dostępne',
    'venue.amenities.furniture': 'Elastyczne Meble',
    'venue.amenities.furnitureDesc': 'Konfigurowalne ustawienia miejsc siedzących i stołów',
    'venue.amenities.parking': 'Parking w Pobliżu',
    'venue.amenities.parkingDesc': 'Płatne opcje parkowania w odległości spaceru',
    'venue.location.title': 'Lokalizacja',
    'venue.location.subtitle': 'Szczegóły',
    'venue.location.description': 'Położony przy Ul. Garbary 96 w sercu Poznania, Pawilon Krzyżanowskiego jest łatwo dostępny ze wszystkich części miasta.',
    'venue.location.address': 'Adres',
    'venue.location.addressValue': 'Ul. Garbary 96, 61-757 Poznań',
    'venue.location.distance': 'Odległość do Starego Miasta',
    'venue.location.distanceValue': 'Mniej niż 500 metrów',
    'venue.location.transport': 'Transport Publiczny',
    'venue.location.transportValue': 'Wiele linii tramwajowych i autobusowych w pobliżu',
    'venue.cta.title': 'Doświadcz Lokalu',
    'venue.cta.description': 'Odwiedź nas, aby zobaczyć nasze historyczne przestrzenie i wyobrazić sobie swoje idealne wydarzenie.',
    'venue.cta.button': 'Umów Wizytę',
    
    // Contact Page
    'contact.hero.title': 'Kontakt',
    'contact.hero.subtitle': 'Skontaktuj się w sprawie rezerwacji i zapytań',
    'contact.form.title': 'Wyślij Nam Wiadomość',
    'contact.form.name': 'Imię',
    'contact.form.email': 'Email',
    'contact.form.phone': 'Telefon',
    'contact.form.message': 'Wiadomość',
    'contact.form.send': 'Wyślij Wiadomość',
    'contact.info.title': 'Informacje Kontaktowe',
    'contact.info.address': 'Adres',
    'contact.info.phone': 'Telefon',
    'contact.info.email': 'Email',
    'contact.info.hours': 'Godziny',
    'contact.info.hoursValue': 'Po Umówieniu',
    
    // Ticket Pages
    'ticket.confirmation.title': 'Płatność ZakoŃczona Pomyślnie',
    'ticket.confirmation.subtitle': 'Twoje bilety zostały potwierdzone',
    'ticket.confirmation.download': 'Pobierz Bilety',
    'ticket.confirmation.print': 'Drukuj Bilety',
    'ticket.confirmation.backToEvents': 'Powrót do Wydarzeń',
    'ticket.confirmation.importantInfo': 'Ważne Informacje',
    'ticket.confirmation.qrCode': 'Kod QR',
    'ticket.confirmation.scanAtVenue': 'Zeskanuj ten kod QR w lokalu',
    'ticket.confirmation.presentQR': 'Proszę okazać ten kod QR przy wejściu do lokalu',
    'ticket.confirmation.saveEmail': 'Zapisz ten email lub zrób zrzut ekranu swojego kodu QR',
    'ticket.confirmation.questions': 'Pytania? Skontaktuj się z nami:',
    
    'ticket.display.title': 'Twój Bilet',
    'ticket.display.event': 'Wydarzenie',
    'ticket.display.date': 'Data',
    'ticket.display.attendee': 'Uczestnik',
    'ticket.display.ticketNumber': 'Numer Biletu',
    'ticket.display.ticketId': 'ID Biletu',
    'ticket.display.qrCode': 'Kod QR',
    'ticket.display.scanAtEntry': 'Pokaż ten kod QR przy wejściu',
    'ticket.display.print': 'Drukuj Bilet',
    'ticket.display.backToEvents': 'Powrót do Wydarzeń',
    
    'ticket.verify.title': 'Weryfikacja Biletu',
    'ticket.verify.scanQR': 'Zeskanuj Kod QR',
    'ticket.verify.enterCode': 'Lub Wprowadź Kod Biletu',
    'ticket.verify.verify': 'Zweryfikuj Bilet',
    'ticket.verify.valid': 'Ważny Bilet',
    'ticket.verify.invalid': 'Nieprawidłowy Bilet',
    'ticket.verify.expired': 'Wygasły Bilet',
    'ticket.verify.alreadyUsed': 'Już Użyty',
    'ticket.verify.eventName': 'Wydarzenie',
    'ticket.verify.attendeeName': 'Uczestnik',
    'ticket.verify.ticketNumber': 'Numer Biletu',
    'ticket.verify.scanCount': 'Liczba Skanowań',
    'ticket.verify.verifyAnother': 'Zweryfikuj Inny Bilet',
    'ticket.verify.enterTicketCode': 'Wprowadź kod biletu ręcznie',
    'ticket.verify.manualVerification': 'Weryfikacja Ręczna',
    'ticket.verify.ticketCode': 'Kod Biletu',
    'ticket.verify.checkQR': 'Proszę sprawdzić kod QR i spróbować ponownie.',
    
    // Additional Cart and Checkout translations
    'cart.soldOutEvent': 'To wydarzenie jest wyprzedane',
    'cart.selectEventFirst': 'Proszę wybrać przynajmniej jedno wydarzenie przed przejściem do płatności.',
    'cart.fillAttendeeInfo': 'Proszę wypełnić imię i email dla wszystkich uczestników',
    'cart.provideAttendeeInfo': 'Proszę podać dane uczestnika',
    'cart.paymentError': 'Wystąpił błąd podczas tworzenia płatności. Spróbuj ponownie.',
    'cart.securePayments': 'Bezpieczne płatności przez Stripe',
    'cart.acceptCards': 'Akceptujemy karty Visa, Mastercard, American Express',
    'cart.processing': 'Przetwarzanie...',
    'cart.loading': 'Ładowanie...',
    'cart.enterFullName': 'Wprowadź pełne imię',
    'cart.enterEmailAddress': 'Wprowadź adres email (twój bilet zostanie wysłany tutaj)',
    'cart.yourEvent': 'Twoje Wydarzenie',
    'cart.tickets': 'Bilety',
    'cart.ticketRequired': 'bilet wymagany',
    'cart.ticketsRequired': 'bilety wymagane',
    'cart.quantity': 'Ilość:',
    'cart.selectEventToSeeDetails': 'Proszę wybrać wydarzenie, aby zobaczyć szczegóły zamówienia',
    
    // Ticket Confirmation additional translations
    'ticket.confirmation.noSessionId': 'Nie znaleziono ID sesji',
    'ticket.confirmation.fetchError': 'Nie udało się pobrać biletów',
    'ticket.confirmation.fetchingTickets': 'Pobieranie biletów dla sesji',
    'ticket.confirmation.errorFetching': 'Błąd podczas pobierania biletów',
    'ticket.confirmation.loadingTickets': 'Ładowanie Twoich Biletów...',
    'ticket.confirmation.pleaseWait': 'Proszę czekać, pobieramy Twoje bilety.',
    'ticket.confirmation.error': 'Błąd',
    'ticket.confirmation.couldNotProcess': 'Nie udało się przetworzyć Twojego biletu. Skontaktuj się z obsługą.',
    'ticket.confirmation.backToHome': 'Powrót do Strony Głównej',
    'ticket.confirmation.noTicketsFound': 'Nie Znaleziono Biletów',
    'ticket.confirmation.couldNotFindTickets': 'Nie udało się znaleźć żadnych biletów dla tej sesji.',
    'ticket.confirmation.paymentSuccessful': 'Płatność Zakończona Pomyślnie',
    'ticket.confirmation.ticketSent': 'Twój bilet został wysłany na Twój email',
    'ticket.confirmation.ticketsSent': 'Twoje bilety zostały wysłane na Twój email',
    'ticket.confirmation.ticketNumber': 'Bilet #',
    'ticket.confirmation.attendee': 'Uczestnik',
    'ticket.confirmation.date': 'Data',
    'ticket.confirmation.price': 'Cena',
    'ticket.confirmation.status': 'Status',
    'ticket.confirmation.active': 'Aktywny',
    'ticket.confirmation.scanQRAtVenue': 'Zeskanuj ten kod QR w lokalu',
    'ticket.confirmation.ticketId': 'ID Biletu',
    'ticket.confirmation.copySent': 'Kopia Twojego biletu została wysłana na',
    'ticket.confirmation.copiesSent': 'Kopia Twoich biletów została wysłana na',
    'ticket.confirmation.presentQRCode': 'Proszę przedstawić ten kod QR przy wejściu do lokalu',
    'ticket.confirmation.ticketUsedOnce': 'Każdy bilet może być użyty tylko raz',
    'ticket.confirmation.ticketsExpire': 'Bilety wygasają dzień po wydarzeniu',
    'ticket.confirmation.printTickets': 'Drukuj Bilety',
    'ticket.confirmation.backToHomeButton': 'Powrót do Strony Głównej',
    
    // Email template translations
    'email.ticket.hello': 'Cześć,',
    'email.ticket.ticketsConfirmed': 'Twój bilet został potwierdzony! Poniżej znajduje się Twój bilet z kodem QR do wejścia.',
    'email.ticket.ticketsConfirmedPlural': 'Twoje bilety zostały potwierdzone! Poniżej znajdują się Twoje bilety z kodami QR do wejścia.',
    'email.ticket.attendee': 'Uczestnik',
    'email.ticket.date': 'Data',
    'email.ticket.price': 'Cena',
    'email.ticket.ticketId': 'ID Biletu',
    'email.ticket.showQRCode': 'Pokaż ten kod QR przy wejściu do lokalu',
    'email.ticket.importantInfo': 'Ważne Informacje',
    'email.ticket.presentQRCode': 'Proszę przedstawić kod QR przy wejściu do lokalu',
    'email.ticket.ticketsExpire': 'Bilety wygasają dzień po wydarzeniu',
    'email.ticket.saveEmail': 'Zachowaj ten email lub zrób zrzut ekranu kodu QR',
    'email.ticket.questions': 'Pytania? Skontaktuj się z nami:',
    'email.ticket.printTickets': 'DRUKUJ BILETY',
    'email.ticket.backToHome': 'POWRÓT DO STRONY GŁÓWNEJ',
    
    // Ticket Display additional translations
    'ticket.display.ticketNotFound': 'Bilet nie znaleziony',
    'ticket.display.loadingTicket': 'Ładowanie biletu...',
    'ticket.display.error': 'Błąd',
    'ticket.display.yourTicket': 'Twój Bilet',
    'ticket.display.active': 'Aktywny',
    'ticket.display.expired': 'Wygasły',
    'ticket.display.cancelled': 'Anulowany',
    'ticket.display.showQRAtEntry': 'Pokaż ten kod QR przy wejściu',
    'ticket.display.name': 'Imię',
    'ticket.display.email': 'Email',
    'ticket.display.eventDate': 'Data Wydarzenia',
    'ticket.display.price': 'Cena',
    'ticket.display.purchaseDate': 'Data Zakupu',
    'ticket.display.expiredAfterEvent': 'Ten bilet wygasł dzień po wydarzeniu',
    'ticket.display.printTicket': 'Drukuj Bilet',
    'ticket.display.browseEvents': 'Przeglądaj Wydarzenia',
    
    // Ticket Verify additional translations
    'ticket.verify.scanning': 'Skanowanie...',
    'ticket.verify.markAsScanned': 'Oznacz jako Zeskanowany',
    'ticket.verify.verifyingTicket': 'Weryfikacja Biletu...',
    'ticket.verify.pleaseWait': 'Proszę czekać podczas weryfikacji biletu.',
    'ticket.verify.invalidTicket': 'Nieprawidłowy Bilet',
    'ticket.verify.ticketNotExist': 'Bilet, który próbujesz zweryfikować, nie istnieje lub został usunięty.',
    'ticket.verify.ticketVerification': 'Weryfikacja Biletu',
    'ticket.verify.validTicket': 'WAŻNY BILET',
    'ticket.verify.validForEntry': 'Ten bilet jest ważny do wejścia',
    'ticket.verify.expiredTicket': 'WYGASŁY BILET',
    'ticket.verify.noLongerValid': 'Ten bilet nie jest już ważny do wejścia',
    'ticket.verify.ticketId': 'ID Biletu',
    'ticket.verify.attendeeInformation': 'Informacje o Uczestniku',
    'ticket.verify.name': 'Imię',
    'ticket.verify.email': 'Email',
    'ticket.verify.scanned': 'Zeskanowany',
    'ticket.verify.times': 'razy',
    'ticket.verify.purchased': 'Zakupiony',
    'ticket.verify.clickToMark': 'Kliknij ten przycisk, gdy uczestnik przybędzie, aby oznaczyć bilet jako zeskanowany.',
    'ticket.verify.expiredOn': 'Wygasł'
  }
};

export const t = (key, language = 'en') => {
  return translations[language][key] || key;
};